import { SidePanel } from '@wix/design-system';
import classNames from 'classnames';
import React from 'react';

import type { LayoutProps } from '../common-types';
import { ROOT } from './data-hooks';
import classes from './floating-desktop-layout-scss';

export const FloatingDesktopLayout: React.FC<LayoutProps> = ({
  onCloseButtonClick,
  dataHook,
  header,
  content,
  footer,
  sidePanelProps,
}) => {
  return (
    <SidePanel
      skin="floating"
      width="360px"
      height="fit-content"
      maxHeight="420px"
      onCloseButtonClick={onCloseButtonClick}
      dataHook={classNames(ROOT, dataHook)}
      {...sidePanelProps}
    >
      {header && <SidePanel.Header {...header} />}
      <SidePanel.Content noPadding {...content} />
      {footer && <SidePanel.Footer className={classes.footer} {...footer} />}
    </SidePanel>
  );
};
